import { render, staticRenderFns } from "./FinderTerms.vue?vue&type=template&id=b3454ace&scoped=true"
import script from "./FinderTerms.vue?vue&type=script&lang=js"
export * from "./FinderTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3454ace",
  null
  
)

export default component.exports